module.exports = __webpack_public_path__ + "img/logo23.4ec33750.jpg";